<template>
  <div class="category-view">
    <!-- v-if="!$route.query.subtype" -->

    <!-- <transition name="fade-in" :duration="1500"> -->
    <!-- :key="`events-${$route.params.slug}`" -->
    <FeaturedEvents
      class="pt-half"
      :title-lg="true"
      :section-header-title="$t(`evType.${$route.params.slug}`)"
      :event-type="$route.params.slug"
      :subtitle="$t('ui.featured')"
      :order-limit="1"
      :collection-name="'concert'"
      :header-has-border-top="false"
    ></FeaturedEvents>
    <!-- </transition> -->

    <!-- :title-lg="selectedSubTypesQuery > 0" -->

    <!-- :class="{'hidden-top-navbar': !$store.state.ui.isNavOpen}" -->
    <nav
      class="navbar is-sticky"
      style="top: 0; z-index: 5060 !important"
      role="filter"
      v-if="!$store.state.ui.isLoading"
    >
      <!-- :class="{'': this.subtypeCard && !$store.state.ui.showCitySelect}" -->
      <div class="tag-rail is-transparent" ref="tagRail">
        <!-- clear filters -->
        <div
          @click="clearFilter"
          :class="{'is-info': !selectedSubTypesQuery}"
          class="tag is-medium"
        >
          <span>{{ $t('ui.all').toLowerCase() }}</span>
        </div>
        <!-- <div class="tags mt-half"> -->
        <span
          class="is-rounded tag is-medium"
          v-for="item of typesArray"
          :key="item.id"
          @click="selectSubType(item)"
          :class="{ 'is-info': selectedSubTypesQuery === item }"
        >{{ $t(`evType.${item}`)}}</span>
      </div>
    </nav>

    <!-- SUBSCRIBE -->
    <div
      class="mx-1"
      style="height: 36px; margin-bottom: 8px; margin-top: 2px"
      v-if="selectedSubTypesQuery"
    >
      <div class="is-flex is-aligned-center is-fullwidth">
        <span
          class="is-size-20px has-text-weight-semibold"
        >{{ $t(`evType.${selectedSubTypesQuery}`) | capitalize }}</span>
        <SubscribeBtn class="ml-auto" :topic="selectedSubTypesQuery" ></SubscribeBtn>
      </div>
    </div>

    <!-- LOADING -->
    <div
      v-show="$store.state.ui.isLoading"
      style="min-height: 52px; width: 100%; overflow:hidden; position: relative"
    >
      <b-loading
        animation
        :is-full-page="false"
        :active="$store.state.ui.isLoading"
        :can-cancel="false"
      ></b-loading>
      <!-- <b-loading animation :is-full-page="false" :active="!isHomePageFetched" :can-cancel="false"></b-loading> -->
    </div>

    <!-- <p>{{ filteredEventsAlt.length }}</p> -->

    <div ref="categoryCards">
      <section class="pt-0" v-if="filteredEventsLength">
        <div class="filtered-date-row" v-for="(event, key) of $options.EVENTS" :key="key">
          <!-- DAY INDICATOR -->
          <!-- <div>{{ event }} </div> -->

          <hr style="margin-top: 0px !important; margin-bottom: 0px !important" />

          <div class="category-cards">
            <!-- :class="{ 'date-indicator--far': !$store.state.ui.isNavOpen }" -->

            <div class="category-card-wrapper">
              <div
                itemscope
                itemtype="http://schema.org/Event"
                class="media-custom category-card has-text-grey-darker no-highlight"
              >
                <!-- v-for="(event, ind) in val"
                :key="event.id + ind"-->
                <div class="grid-gap"></div>
                <div class="media-custom--left">
                  <!-- @click.native="$store.commit('appData/SET_DISPLAYED_EVENT', event)" -->
                  <router-link
                    :to="{ name: 'event-view', params: { eventID: event.id, eventPreview: event }}"
                    @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name:event.data.eventName, button_name: 'event_img_on_category_card'})"
                  >
                    <figure class="image" >
                      <img
                        itemprop="image"
                        class="is-lazy"
                        
                        lazy="loaded"
                        v-if="event.data.eventImagePaths.posterURLs"
                        v-lazy="event.data.eventImagePaths.posterURLs[0]"
                        :alt="event.data.eventName"
                      />
                    </figure>
                  </router-link>
                </div>
                <div class="grid-gap"></div>

                <div class="media-custom--content">
                  <div style="height: 100%; transform: translateY(-2px)">
                    <div
                      class="card-row mt-0"
                      style="padding-top: 2px; padding-bottom: 4px"
                      v-if="selectedSubTypesQuery === 'all'"
                    >
                      <p
                        class="is-size-xs"
                      >{{ $t(`evType.${event.data.eventSubTypes[0]}`) | toUpperCaseTurkish }}</p>
                    </div>

                
                    <!-- EVENT TITLE -->
                    <router-link
                      @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name:event.data.eventName, button_name: 'event_title_on_category_card'})"
                      :to="{ name: 'event-view', params: { eventID: event.id, eventPreview: event }}"
                      class="card-row cursor-link no-highlight"
                    >
                      <h4
                        itemprop="name"
                        style="line-height: 1.25; padding-bottom: 2px"
                        class="has-text-black-bis has-text-weight-medium is-size-6 mb-0 card-row"
                      >{{ event.data.eventName }}</h4>
                    </router-link>

                       <!-- DATETIME -->
                    <CardDatetime
                    class="is-size-15px"
                      v-if="event.data.eventShowtimes"
                      :show-type="true"
                      :event-showtimes="event.data.eventShowtimes"
                      :font-sm="false"
                      :show-extra-dates="true"
                      :onlyDate="false"
                    ></CardDatetime>


                    <!-- EVENT Venue -->
                    <CardVenue
                      class="is-size-14px is-inline-block"
                      :show-venue-logo="false"
                      :show-venue="true"
                      :event-venue-name="event.data.eventVenueName"
                      :event-venue-id="event.data.eventVenueID"
                      :event-venue-avatar-url="event.data.eventVenueAvatarURL"
                      :event-venue-rich-address="event.data.eventVenueRichAddress"
                    ></CardVenue>

                    <!-- EVENT PRICE -->
                    <CardPrice
                      :is-medium="true"
                      :event-ticket-info="event.data.eventTicketInfo"
                      :event-id="event.id"
                    ></CardPrice>
                  </div>
                </div>

                <div
                  style="display:flex; justify-content: space-between; flex-wrap: wrap; height: 100%;flex-wrap: wrap; flex-flow: column;"
                >
                  <StarBtn :event="event"></StarBtn>

                  <router-link
                    @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name:event.data.eventName, button_name: 'chevron_on_category_card'})"
                    :to="{ name: 'event-view', params: { eventID: event.id, eventPreview: event }}"
                    class="card-row cursor-link no-highlight"
                    style="margin-top: 2px"
                  >
                    <span class="icon has-background-white-ter is-rounded is-medium">
                      <i class="mdi mdi-chevron-right mdi-24px"></i>
                    </span>
                  </router-link>
                </div>

                <!-- <router-link
                  class="media-custom--action no-highlight"
                  @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name:event.data.eventName, button_name: 'event_title_on_category_card'})"
                  :to="{ name: 'event-view', params: { eventID: event.id, eventPreview: event }}"
                >
                 
                </router-link>-->
              </div>
            </div>
          </div>

          <!-- </div> -->
        </div>
      </section>
    </div>

    <!-- LOAD MORE -->
    <div class="mx-1 mb-2 mt-2" v-if="false">
      <button
        @click="loadMore"
        class="button is-fullwidth is-primary is-outlined"
      >{{$t('ui.loadMore')}}</button>
    </div>

    <button
      class="has-background-info button"
      @click="scrollToTop"
      style="position: fixed; right: 10px; bottom: 48px;  border-radius: 50%; width: 48px; height: 48px; z-index: 5060"
    >
      <span class="icon has-text-white is-medium">
        <i class="mdi mdi-chevron-up mdi-24px"></i>
      </span>
    </button>

    <!-- NOT FOUND EVENTS -->
    <section
      style="margin-top: 28px; margin-bottom: 64px"
      v-if="!filteredEventsLength && !$store.state.ui.isLoading"
    >
      <p class="mx-1-half has-text-centered">{{$t('ui.eventsByTypeNotFound')}}</p>

      <div class="mx-1-half mt-1 has-text-centered">
        <div
          @click="clearFilter"
          class="has-text-link"
        >{{ $route.params.slug ? $t('ui.seeAllEventsOfType', { msg: $t(`evType.${$route.params.slug}`).toLowerCase() }) : '' }}</div>

        <hr class="hr-text mt-half mb-half" style="width: 25%;margin: 0 auto;" :data-content="$t('ui.or')" />

        <router-link :to="{name:'home'}">{{ $t('ui.backToHomePage') }}</router-link>
      </div>
    </section>
    <!-- END: NOT FOUND EVENTS -->
  </div>
</template>

<script>
import FeaturedEvents from "@/components/rails/FeaturedEvents";

import CardDatetime from "@/components/shared/CardDatetime";
import CardPrice from "@/components/shared/CardPrice";
import CardVenue from "@/components/shared/CardVenue";

import StarBtn from "@/components/shared/StarBtn";
import SubscribeBtn from "@/components/shared/SubscribeBtn";

import { mapGetters } from "vuex";
// import { arrayUnique } from "@/utilities/arrayHelpers";

export default {
  name: "events",
  components: {
    FeaturedEvents,
    CardDatetime,
    SubscribeBtn,
    // SectionHeader,
    CardPrice,
    StarBtn,
    CardVenue
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.metaEventType,
      // all titles will be injected into this template
      titleTemplate: "%s | hafta8.com",
      meta: [
        {
          name: "description",
          content:
            this.metaEventType +
            ": " +
            this.concatedTypesArray.join(", ") +
            " | " +
            "hafta8.com"
        },
        {
          name: "keywords",
          content: `Şehir, etkinlik, konser, tiyatro, sahne, atölye, festival, bilet al, etkinlikler`
        },

        { name: "twitter:card", content: "summary" },
        {
          name: "twitter:title",
          content: this.metaEventType + " | hafta8"
        },
        {
          name: "twitter:description",
          content:
            this.metaEventType +
            ": " +
            this.concatedTypesArray.join(", ") +
            " | " +
            "hafta8.com"
        },
        {
          name: "twitter:image",
          content: ""
        },

        { vmid: "og:type", property: "og:type", content: "article" },
        {
          property: "og:title",
          content: this.metaEventType + " | hafta8"
        },
        {
          property: "og:description",
          content:
            this.metaEventType +
            ": " +
            this.concatedTypesArray.join(", ") +
            " | " +
            "hafta8.com"
        },
        {
          property: "og:image",
          content: ""
        },
        {
          property: "og:url",
          content: window.location.href
        }
      ],
      link: [
        {
          rel: "canonical",
          href: window.location.href
        }
      ]
    };
  },
  data() {
    return {
      selectedSubTypesQuery: "",
      events: [],
      fetchedEvents: [],
      filteredEventsLength: 0,
      filteredEventsByDate: {},
      // today: new Date(),
      // dayDifferenceInList: "",
      // firstMonthInList: 0,
      // firstDayInList: 0,
      // lastMonthInList: 0,
      // lastDayInList: 0,
      // refs
      dayIndicatorRefs: [],
      // calendarRange: [],
      showCalendarRail: false,
      EVENT_LIMIT: 30
    };
  },
  created() {
    console.log("EVENTS COMP CREATED");
    if (this.user) {
      this.initComp();
    }
  },
  watch: {
    user(val) {
      if (val) {
        console.log("user in watcher: ", val);
        this.initComp();
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "user/userDoc"
    }),
    metaEventType() {
      if (this.$route.params.slug)
        return (
          this.$store.state.user.userCity +
          " " +
          this.$t(`evType.${this.$route.params.slug}`).toLocaleLowerCase() +
          " " +
          this.$t("ui.ofEvents") +
          ", " +
          this.$t("ui.ofTickets")
        );
      else return "";
    },
    concatedTypesArray() {
      let typesArray = [];
      let vm = this;
      if (this.$route.name !== "events") return [];
      if (!this.$route.params.slug) return [];
      if (this.$store.state.appData.eventTypes)
        Object.keys(
          this.$store.state.appData.eventTypes[this.$route.params.slug]
        ).forEach(k => {
          typesArray.push(vm.$t(`evType.${k}`));
        });
      // console.log("typesArray", typesArray);
      return typesArray;
    },
    typesArray() {
      let typesArray = [];
      if (!this.$route.params.slug) return [];
      if (this.$store.state.appData.eventTypes)
        Object.keys(
          this.$store.state.appData.eventTypes[this.$route.params.slug]
        ).forEach(k => typesArray.push(k));
      // console.log("typesArray", typesArray);
      return typesArray;
    },
    headerTitle() {
      let title = "";

      if (this.$route.query.subtype) {
        title = this.$t(`evType.${this.$route.params.slug}`);
      } else if (this.$route.params.slug !== "theatre") {
        title =
          this.$options.filters.capitalize(this.$t(`evType.all`)) +
          " " +
          this.$t(`evType.${this.$route.params.slug}s`);
      } else {
        title =
          this.$options.filters.capitalize(this.$t(`evType.all`)) +
          " " +
          this.$t(`evType.theaters`);
      }
      return title;
    }
  },
  methods: {
    initComp() {
      console.log("query params at init comp", this.$route.query.subtype);

      // get query subytpe params
      if (this.$route.query.subtype) {
        this.selectedSubTypesQuery = this.$route.query.subtype;
      }

      this.fetchEventsByType();
    },
    filterEvents() {
      let list = [];

      // filter by main type
      // list = this.fetchedEvents.length
      //   ? this.fetchedEvents.filter(
      //       e => e.data.eventMainType === this.$route.params.slug
      //     )
      //   : [];
      list = this.$options.FETCHED_EVENTS.length
        ? this.$options.FETCHED_EVENTS.filter(
            e => e.data.eventMainType === this.$route.params.slug
          )
        : [];

      // filter by subtype
      if (this.selectedSubTypesQuery) {
        list = list.filter(e => {
          return e.data.eventSubTypes.includes(this.selectedSubTypesQuery);
        });
      }

      // console.log("list: ", list);
      this.$options.EVENTS = list;

      this.filteredEventsLength = list.length;

      return "";

      let filteredEventsAlt = [];
      list.forEach((e, ind) => {
        Object.keys(e.data.eventShowtimes).forEach(k => {
          const event = JSON.parse(JSON.stringify(e));
          event.data.eventShowtimesAlt = {};
          event.data.eventShowtimesAlt[0] = e.data.eventShowtimes[k];
          event.data.eventShowtimesAlt[0].startTime = new Date(
            e.data.eventShowtimes[k].startTime
          );
          event.data.eventShowtimesAlt[0].endTime = new Date(
            e.data.eventShowtimes[k].endTime
          );
          filteredEventsAlt.push(event);
        });
      });

      // sort by datetime
      filteredEventsAlt = filteredEventsAlt.sort(
        (a, b) =>
          a.data.eventShowtimesAlt[0].startTime -
          b.data.eventShowtimesAlt[0].startTime
      );

      let filteredEvents = {};
      // organize by date
      if (!list.length) {
        this.filteredEventsByDate = filteredEvents;
      } else {
        filteredEventsAlt.forEach((e, ind) => {
          const key = this.$options.filters.toCategoryDateTime(
            e.data.eventShowtimesAlt[0].startTime
          );

          if (!filteredEvents[key]) {
            filteredEvents[key] = [];
          }

          filteredEvents[key].push(e);
        });
      }
      this.filteredEventsLength = Object.keys(filteredEvents).length;
      this.$options.EVENTS = filteredEvents;
    },
    async fetchEventsByType() {
      this.$store.commit("ui/SET_LOADING", true);

      let events = [];
      try {
        events = await this.$store.dispatch("appData/fetchEventsByType", {
          eventType: this.$route.params.slug,
          orderLimit: this.EVENT_LIMIT
        });
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.log(error);
        }
      }

      this.$options.FETCHED_EVENTS = events;

      this.filterEvents();
      this.$store.commit("ui/SET_LOADING", false);
    },
    // filter
    selectSubType(val) {
      console.log("REF REF");
      if (window.pageYOffset > this.$refs.categoryCards.offsetTop) {
        window.scrollTo({ top: this.$refs.categoryCards.offsetTop - 104 });
      }

      // query update
      this.selectedSubTypesQuery = val;
      this.filterEvents();
    },
    clearFilter() {
      this.selectedSubTypesQuery = "";
      this.filterEvents();
    },
    // end: filter
    humanDate(val) {
      if (val)
        return `${val.getDate()} ${this.$t(
          `monthNames.${val.getMonth()}`
        ).slice(0, 3)}`;
    },
    isToday(month, date, day) {
      const today = new Date();
      let tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);

      if (
        today.getDate() === parseInt(date) &&
        today.getMonth() === parseInt(month)
      ) {
        return {
          date:
            this.$t("ui.today") +
            ", " +
            parseInt(date) +
            " " +
            this.$t(`monthNames.${parseInt(month)}`),
          isHighlighted: true
        };
      } else if (
        tomorrow.getDate() === parseInt(date) &&
        tomorrow.getMonth() === parseInt(month)
      ) {
        return {
          date:
            this.$t("ui.tomorrow") +
            ", " +
            parseInt(date) +
            " " +
            this.$t(`monthNames.${parseInt(month)}`),
          isHighlighted: true
        };
      } else {
        return {
          date:
            this.$t(`dayNames.${day}`) +
            ", " +
            parseInt(date) +
            " " +
            this.$t(`monthNames.${parseInt(month)}`),
          isHighlighted: false
        };
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
   
  }
};
</script>

<style lang="scss" scoped>
.section-header--wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 40px;
  // width: 100%;
  align-items: center;
}
.section-title {
  line-height: 1.35 !important;
  // flex-grow: 1;
}

.calendar-day-rail-grid {
  width: 100%;
  display: grid;
  // grid-template-columns: minmax(100%, 1fr);
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-scroll-snap-type: mandatory;
  -webkit-scroll-snap-destination: 50% 50%;
  position: sticky;
  top: 0;
  z-index: 10051;
}

.calendar-scroll--wrapper {
  -webkit-scroll-snap-coordinate: 50% 50%;
  scroll-snap-align: start;
  // top: 52px;
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(7, 1fr);
  background-color: $white-ter;
}

.calendar--day-indicator {
  width: 100%;
  // height: 88px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
}
.calendar--day-name {
  padding-bottom: 0px;
  padding-top: 6px;
}

.calendar--day-number--wrapper {
  padding-top: 4px;
  padding-bottom: 4px;
}

.calendar--day-number {
  height: 36px;
  width: 36px;
  margin: 0 auto;
  // border: 1px solid $grey-lighter;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.calendar--day-number.is-focused {
  // border: 1px solid $info;
  background-color: $info;
  color: white;
}

nav.navbar[role="filter"] {
  width: 100%;
  z-index: 5030 !important;
}

.has-transition {
  transition: all 260ms ease-out;
}

.is-transparent {
  background: transparent !important;
}

.tag-rail {
  margin: 0 0;
  padding: 0.5rem !important;
}

.tag-rail .tag {
  position: relative;
  margin: 0.125rem 0.25rem 0 0.25rem;
  border-radius: 24px;
}

.filtered-date-row {
  transition: all 300ms ease-out;
}

.card-row {
  font-weight: 400;
  font-size: 14px;
}
.card-row .image {
  background-color: $grey-light;
  border-radius: 50%;
}

$date-indicator-width: 42px;

.day-indicator {
  padding: 0.125rem 1rem;
  width: 100%;
  background-color: $white-ter;
  position: sticky;
  // top: calc(67px);
  transition: top 270ms ease-out;
  z-index: 50;
  border-top: 1px solid $grey-lighter;
  border-bottom: 1px solid $grey-lighter;
}

.category-card-wrapper {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
  position: relative;
  height: 100%;
}



.tag-rail {
  // height: 52px;
  padding: 0.25rem 1rem 0.25rem 0.75rem;
  // max-height: 260px;
  background-color: #fff;

  /* Make this scrollable when needed */
  overflow-x: auto;
  /* We don't want vertical scrolling */
  overflow-y: hidden;
  /* Make an auto-hiding scroller for the 3 people using a IE */
  -ms-overflow-style: -ms-autohiding-scrollbar;
  /* For WebKit implementations, provide inertia scrolling */
  -webkit-overflow-scrolling: touch;
  /* We don't want internal inline elements to wrap */
  white-space: nowrap;
  /* Remove the default scrollbar for WebKit implementations */
  &::-webkit-scrollbar {
    display: none;
  }
}

.card-row h4 {
  line-height: 1.3 !important;
}

.event-card span {
  display: inline !important;
}

.event-header .title {
  margin-bottom: 0 !important;
}

$card-width: 64px;
$card-width-lg-device: 120px;

$breakpoint-lg: 1000px;

.media-custom {
  display: grid;
  grid-template-columns: 16px $card-width 12px 1fr 42px;
}

.media-custom--left figure.image {
  border-radius: 2px;
  overflow: hidden;
  width: $card-width;
  // height: 100%;
  min-height: $card-width;

  img {
    min-height: $card-width;
  }

  @media screen and (min-width: $breakpoint-lg) {
    width: $card-width-lg-device;
    height: $card-width-lg-device * 1.4;
    min-height: $card-width-lg-device * 1.4;
    max-height: $card-width-lg-device * 1.4 !important;
  }
  -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  -moz-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
}

.media-custom--left figure.image img {
  object-fit: cover;
}

.media-custom + .media-custom {
  border-top: 1px solid $grey-lighter;
}

.media-left img {
  height: 100%;
}

.tag.is-active {
  border: 2px solid $info;
  background-color: $white-bis;
}



</style>